module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_golanov_sm-c415134d7b7a52ed67489bafde32cfaa.png";